import { render, staticRenderFns } from "./withdrawals.vue?vue&type=template&id=3bb6cb2c"
import script from "./withdrawals.vue?vue&type=script&lang=js"
export * from "./withdrawals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports